import React, { useEffect, useState } from "react";
import { supabase } from "../../../utils/supabase";
import SerialTagAutocomplete from "./SerialTagAutocomplete";

export default function IntakeDrawer({ open, onClose, intakeId, client }) {
  const clientId = client?.id;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadItems() {
    if (!intakeId) return;
    setLoading(true);
    // Traemos items + datos de instrumento
    const { data, error } = await supabase
      .from("intake_items")
      .select(`
        id,
        created_at,
        instrument:instruments ( id, lab_id, tag, serial, brand, model, type )
      `)
      .eq("intake_id", intakeId)
      .order("created_at");
    if (!error) setItems(data || []);
    setLoading(false);
  }

  useEffect(() => {
    if (open) loadItems();
  }, [open, intakeId]);

  async function addInstrument(inst) {
    const { error } = await supabase.rpc("add_instrument_to_intake", {
      p_intake_id: intakeId,
      p_instrument_id: inst.id,
      p_note: null,
    });
    if (error) {
      alert(error.message || "No se pudo agregar");
      return;
    }
    await loadItems();
  }

  function handlePrintReceipt() {
    if (!intakeId) return;
    const url = `/ingresos/comprobante?intakeId=${encodeURIComponent(
      intakeId
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-xl bg-[#0F1115] text-white border-l border-white/10 p-5 overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold">
              Ingreso provisorio — {client?.name || ""}
            </h3>
            <p className="text-xs opacity-70 mt-1">
              {items.length === 0
                ? "Todavía no hay instrumentos cargados."
                : `${items.length} instrumento${
                    items.length === 1 ? "" : "s"
                  } en este ingreso.`}
            </p>
          </div>
          <div className="flex items-center gap-2">
            {items.length > 0 && (
              <button
                type="button"
                className="px-3 py-1.5 rounded-md border border-emerald-400/60 text-emerald-300 hover:bg-emerald-500/10 text-xs"
                onClick={handlePrintReceipt}
              >
                Imprimir comprobante
              </button>
            )}
            <button
              type="button"
              className="px-3 py-1.5 rounded-md border border-white/10 text-xs"
              onClick={onClose}
            >
              Cerrar
            </button>
          </div>
        </div>

        {/* Buscador / alta rápida */}
        <div className="mb-4">
          <label className="block text-sm mb-1">
            Agregar instrumento (Serie / Tag del cliente)
          </label>
          <SerialTagAutocomplete
            clientId={clientId}
            onPick={addInstrument}
            onCreateNew={() =>
              alert(
                "Primero creá el instrumento en el formulario normal, luego volvés y lo agregás al intake."
              )
            }
            placeholder="Buscar por Serie o Tag…"
          />
          <p className="text-xs opacity-70 mt-1">
            El buscador filtra solo instrumentos de este cliente.
          </p>
        </div>

        {/* Tabla de instrumentos del ingreso */}
        <div className="rounded-md border border-white/10">
          <div className="bg-white/5 px-3 py-2 text-sm">
            Instrumentos en este ingreso
          </div>
          {loading ? (
            <div className="px-3 py-3 text-sm">Cargando…</div>
          ) : items.length === 0 ? (
            <div className="px-3 py-3 text-sm opacity-70">
              Aún no agregaste instrumentos.
            </div>
          ) : (
            <div className="overflow-x-auto">
            <table className="w-full min-w-[560px] text-sm">
              <thead className="bg-white/5">
                <tr>
                  <th className="px-3 py-2 text-left">Lab ID</th>
                  <th className="px-3 py-2 text-left">Tag</th>
                  <th className="px-3 py-2 text-left">Serie</th>
                  <th className="px-3 py-2 text-left">Marca/Modelo</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id} className="border-t border-white/10">
                    <td className="px-3 py-2">
                      {it.instrument?.lab_id || "—"}
                    </td>
                    <td className="px-3 py-2">
                      {it.instrument?.tag || "—"}
                    </td>
                    <td className="px-3 py-2">
                      {it.instrument?.serial || "—"}
                    </td>
                    <td className="px-3 py-2">
                      {(it.instrument?.brand || "")}{" "}
                      {(it.instrument?.model || "")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>

        <p className="text-xs opacity-70 mt-3">
          El comprobante de recepción se imprime con el botón{" "}
          <b>“Imprimir comprobante”</b>. Luego, desde la OC real, usá el botón{" "}
          <b>“Vincular ingreso”</b> para pasar estos instrumentos a la Orden de
          Servicio.
        </p>
      </div>
    </div>
  );
}
